




















































































































import Vue from "vue";
import { mapGetters, mapState } from "vuex";

import { dataTableItemsPerPage } from "@/utility/Constants";

import { RootState } from "@/store";

// Vue components
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import TagsFilter from "@/components/TableHeaderFilters/TagsFilter.vue";
import ScheduleConfigurationComponent from "./ScheduleConfigurationComponent.vue";
import EditSchedule from "./EditSchedule.vue";

// Model
import { ScheduleTypeEnum } from "@/model/data/scheduleSettings/ScheduleTypeEnum";
import { ScheduleFrequencyEnum } from "@/model/data/scheduleSettings/ScheduleFrequencyEnum";
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { LicenseData } from "@/model/data/License/LicenseData";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import EditScheduleDialog from "./EditScheduleDialog.vue";

export default Vue.extend({
    components: {
        TableFiltersRow,
        EditSchedule,
        ScheduleConfigurationComponent,
        EditScheduleDialog,
    },
    data() {
        return {
            ScheduleFrequencyEnum,
            ScheduleTypeEnum,
            dataTableItemsPerPage,
            options: {},
            ignoreOptionsChanges: false,
            showDialog: false,
            selectedInstallations: [],
            availableHeader: [
                {
                    text: this.$t("common.name"),
                    value: "name",
                    sortable: true,
                    enabled: true,
                },
                {
                    text: this.$t("common.branch"),
                    value: "branch.name",
                    sortable: true,
                    enabled: true,
                },
                {
                    text: this.$t("common.tags"),
                    value: "tags",
                    sortable: false,
                    enabled: false,
                    align: "center",
                },
            ],
            filters: [
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "tags",
                    filterKey: "tagValues",
                    component: TagsFilter,
                    currentSelections: [],
                },
            ],
        };
    },
    computed: {
        ...mapState({
            licenseData: (state: RootState): any => state.license.licenseModules,
        }),
        ...mapGetters(["authUserHasPrivilege"]),

        tableHeader() {
            let ret = [];
            this.availableHeader.filter((c) => c.enabled).forEach((c) => ret.push(c));

            if ((this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.ServiceAndUpdatesManagement)) {
                if (this.authUserHasPrivilege(ClientPrivileges.UpdatesManagement)) {
                    ret.push({
                        text: this.$t("scheduleConfiguration.updateSettings"),
                        value: "updateSettings",
                        sortable: false,
                        enabled: true,
                    });
                }

                if (this.authUserHasPrivilege(ClientPrivileges.DownloadLogs)) {
                    ret.push({
                        text: this.$t("scheduleConfiguration.logDownload"),
                        value: "logDownload",
                        sortable: false,
                        enabled: true,
                    });
                }
            }

            if (
                (this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.SecurityManagement) &&
                (this.authUserHasPrivilege(ClientPrivileges.SecurityManagement) || this.authUserHasPrivilege(ClientPrivileges.SecurityScheduleWrite))
            ) {
                ret.push({
                    text: this.$t("scheduleConfiguration.securitySettings"),
                    value: "securitySettings",
                    sortable: false,
                    enabled: true,
                });
            }

            if ((this.licenseData as LicenseData).isAvailable(LicenseModuleEnum.SecurityManagement) && this.authUserHasPrivilege(ClientPrivileges.CaosConfigurationManagement)) {
                ret.push({
                    text: this.$t("scheduleConfiguration.caosConfigurationBackup"),
                    value: "caosConfigurationBackup",
                    sortable: false,
                    enabled: true,
                });
            }

            return ret;
        },
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        installations: { required: true, type: Array },
    },
    watch: {
        options: {
            handler(newOptions) {
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
    },
    methods: {
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },

        onDialogClose(value) {
            if (value.forceRefresh) {
                this.$emit("reload");
                this.selectedInstallations.splice(0, this.selectedInstallations.length);
            }

            this.showDialog = false;
        },
    },
});
